// @vue/component
import {useChallengeStore} from "@/stores/WheelAnalysis/challenge";
import {storeToRefs} from "pinia";

export default {
  name: 'ChallengeStatement',

  components: {},

  mixins: [],

  props: {},

  setup() {
    const challengeStore = useChallengeStore()

    const { challengeType } =  storeToRefs(challengeStore)
    const { challengeStatement } =  storeToRefs(challengeStore)
    const { editMode } =  storeToRefs(challengeStore)

    return { challengeStore, challengeType, challengeStatement, editMode }

  },

  computed: {},

  watch: {
  },

  mounted () {
    this.challengeStore.fetchWheelAnalysis()
  },

  methods: {}
}
